import { render, staticRenderFns } from "./OffersSection.vue?vue&type=template&id=4daa70d4"
import script from "./OffersSection.vue?vue&type=script&lang=js"
export * from "./OffersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports